import { React } from "react";
import {
  CardMedia,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: 22,
    height: 22,
  },
  text: {
    marginLeft: 8,
    fontSize: 14,
  },
}));

function BankSelector({ onChange, bankSeller, className, selectedBank }) {
  const classes = useStyles();
  const translate = useTranslate();
  if (bankSeller === null) return null;
  return (
    <Autocomplete
      className={className}
      options={bankSeller}
      getOptionLabel={(option) => option.bankName}
      onChange={(_, value) => onChange(value)}
      value={selectedBank}
      renderOption={(option) => {
        return (
          <>
            <CardMedia className={classes.icon} image={option.icon} />

            <Typography className={classes.text}>{option.bankName}</Typography>
          </>
        );
      }}
      renderInput={(params) => (
        <TextField
          variant="outlined"
          placeholder={translate("ra.text.paymentMethod.enterBankName")}
          {...params}
        />
      )}
    />
  );
}

export default BankSelector;
